<template>
  <div class="container">
  <div class="center">
    <h2>Add an attachment</h2>
  <br />
    <label>File
      <input type="file" id="file_upload" ref="file" v-on:change="handleFileUpload()"/>
    </label>
      <v-btn v-on:click.prevent="submitFile()">Upload</v-btn>
  </div>
  <br />
  <hr />
  <br />
  <div class="noattachments" v-if="!list.length">No existing attachments</div>
  <table v-if="list.length" class="attachments">
    <thead>
      <th></th>
      <th>Filename</th>
      <th>Size</th>
      <th>Link</th>
    </thead>
    <tr v-for="f in list" v-bind:key="f.uuid"> 
      <td><a :href="file_url(f)" target="_blank" ><img class="thumbnail" :src="file_url(f)" /></a></td>
      <td>{{ f.file_name }}</td>
      <td>{{ f.file_size }}</td>
      <td><input v-on:click="attach_select($event)" :value="file_url(f)" type="text" readonly class="attachment_link" /></td>
    </tr>
  </table>
  <div v-if="list.length" class="center">Click link to copy to clipboard&nbsp;<span v-if="copyClicked" class="copyClicked">(Copied!)</span></div>

  </div>

</template>
<style scoped>
.center {
  text-align: center;
}
</style>

<script>
  import axios from '../lib/axios'
  const log = console.log
  import _ from 'lodash'

  export default {
    data() {
      return {
        uuid: 0,
        file: '',
        list: [],
        copyClicked: false,
        upload: '',
        busy: false
      }
    },
    props: {
        parent : Object
    },
    created() {
        this.refresh()
    },
    methods: {
      refresh() {
            var self = this
            let el_upload = document.getElementById("file_upload")
            if (el_upload) el_upload.value = ''
            
            if (!self.parent.uuid) return

            axios.get('/api/docs/?_item=attachment&_parent='+self.parent.uuid)
            .then(function (response) {
                if (response.data.status == "error") {
log('ERROR','FileUpload.list','Request failed',response)
                    return false;
                }
                self.list = response.data.data
            })
            .catch((err) => {
                log('ERROR','FileUpload.list', err.message)
            });
      },
      attach_select(r) {
        r.target.select()
        r.target.setSelectionRange(0, 99999)
        document.execCommand("copy")
        this.copyClicked = true
        _.delay(()=>this.copyClicked=false,3000)
log('DEBUG','attach_select',r.target.textContent)
      },
      handleFileUpload() {
        this.file = this.$refs.file.files[0]
      },
      file_url(f) {
          if (!f || !f.content || !f.content.self) return '/static/unknown.gif'
          return f.content.self
          //return '/api/docs/'+f.uuid+'+/content'
      },
      submitFile() {
        var self = this
        let formData = new FormData()
        formData.append('file', this.file)
        formData.append('_parent',this.parent.uuid)
        self.busy = true
        axios.post( '/api/docs/'+this.uuid+'/content',
          formData, 
          {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
          }
        ).then(function(r){
            console.log('DEBUG','FileUpload:submitFile', 'SUCCESS!!', r)
            self.busy = false
            self.refresh()
        })
        .catch(function(e){
          console.log('ERROR','FileUpload:submitFile', 'Attempt failed', e);
            self.busy = false
        })
        return false
      },
    }
  }
</script>
<style scoped>
.noattachments {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}
.attachments {
    margin-left: auto;
    margin-right: auto;

}
.attachment_link {
    width: 400px
}
.copyClicked {
    font-weight: bold;
}
.thumbnail {
    height: 40px
}
@keyframes spinner {
      to { transform: rotate(360deg); }
}
.fa-spinner {
      /* Apply 'spinner' keyframes looping once every second (1s)  */
        animation: spinner 1s linear infinite;
}
</style>

